// extracted by mini-css-extract-plugin
module.exports = {"label":"Checkbox_label__yriM0","checkboxView":"Checkbox_checkboxView__390aB","checkbox":"Checkbox_checkbox__61EGd"};